import React from 'react'

const TextBox = ({ label, type, inputName, onChange, inputValue }) => {
    return (
        <div className='my-1'>
            <label className="block text-sm font-medium text-gray-700">{label}</label>
            <input
                type={type}
                name={inputName}
                value={inputValue}
                onChange={(e) => onChange(e)}
                className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-xs md:text-base"
                required
            />
        </div>
    )
}

export default TextBox